import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from './stores/auth.js';

/* У каждой роли своя стартовая страница: оператор попадает на свой станок,
   мастер — на участок, руководство — на сводку. Одного «главного экрана»
   для всех нет: у смены за станком и у директора разные задачи. */
export const HOME_BY_ROLE = {
  operator: '/operator',
  qc: '/quality',
  setter: '/maintenance',
  planner: '/orders',
  supervisor: '/supervisor',
  manager: '/manager',
  admin: '/admin',
};

const routes = [
  { path: '/', redirect: () => HOME_BY_ROLE[useAuthStore().role] || '/login' },

  { path: '/login', name: 'login', component: () => import('./views/LoginView.vue'), meta: { public: true } },
  { path: '/terminal', name: 'terminal', component: () => import('./views/TerminalLoginView.vue'), meta: { public: true } },

  {
    path: '/operator', name: 'operator', component: () => import('./views/OperatorView.vue'),
    meta: { roles: ['operator', 'supervisor', 'admin'] },
  },
  {
    path: '/orders', name: 'orders', component: () => import('./views/OrdersView.vue'),
    meta: { roles: ['planner', 'manager', 'admin'] },
  },
  {
    path: '/supervisor', name: 'supervisor', component: () => import('./views/SupervisorView.vue'),
    meta: { roles: ['supervisor', 'manager', 'admin'] },
  },
  {
    path: '/quality', name: 'quality', component: () => import('./views/QualityView.vue'),
    meta: { roles: ['qc', 'supervisor', 'manager', 'admin'] },
  },
  {
    path: '/stock', name: 'stock', component: () => import('./views/StockView.vue'),
    meta: { roles: ['supervisor', 'manager', 'admin'] },
  },
  {
    path: '/melt', name: 'melt', component: () => import('./views/MeltView.vue'),
    meta: { roles: ['operator', 'supervisor', 'manager', 'admin'] },
  },
  {
    path: '/lab', name: 'lab', component: () => import('./views/LabView.vue'),
    meta: { roles: ['qc', 'supervisor', 'manager', 'admin'] },
  },
  {
    path: '/maintenance', name: 'maintenance', component: () => import('./views/MaintenanceView.vue'),
    meta: { roles: ['setter', 'supervisor', 'manager', 'admin'] },
  },
  {
    path: '/scrap', name: 'scrap', component: () => import('./views/ScrapView.vue'),
    meta: { roles: ['supervisor', 'manager', 'admin'] },
  },
  {
    path: '/certificates', name: 'certificates', component: () => import('./views/CertificatesView.vue'),
    meta: { roles: ['qc', 'supervisor', 'manager', 'admin'] },
  },
  {
    path: '/batches', name: 'batches', component: () => import('./views/BatchesView.vue'),
    meta: { roles: ['supervisor', 'manager', 'admin', 'qc'] },
  },
  {
    path: '/shift', name: 'shift', component: () => import('./views/ShiftReportView.vue'),
    meta: { roles: ['supervisor', 'manager', 'admin'] },
  },
  {
    path: '/manager', name: 'manager', component: () => import('./views/ManagerView.vue'),
    meta: { roles: ['manager', 'admin', 'supervisor', 'planner'] },
  },
  {
    path: '/admin', name: 'admin', component: () => import('./views/AdminView.vue'),
    meta: { roles: ['admin'] },
  },
  /* Андон — цеховое табло. fullscreen убирает панель навигации и шапку:
     экран висит на стене, ходить по разделам с него некому. */
  {
    path: '/andon', name: 'andon', component: () => import('./views/AndonView.vue'),
    /* open: экран открывается и по сессии человека, и по ключу устройства.
       Ни public (тот уводит вошедшего на его домашний экран), ни обычный
       защищённый: у табло на стене нет учётной записи вообще. */
    meta: { fullscreen: true, open: true },
  },

  { path: '/:pathMatch(.*)*', redirect: '/' },
];

export const router = createRouter({ history: createWebHistory(), routes });

router.beforeEach(async (to) => {
  const auth = useAuthStore();

  // Первый переход ждёт восстановления сессии, иначе перезагрузка выкинет на вход
  if (!auth.ready) await auth.restore();

  // Табло: пускаем и человека, и устройство — разбираться будет сам экран
  if (to.meta.open) return true;

  if (to.meta.public) {
    if (auth.isAuthenticated) return HOME_BY_ROLE[auth.role] || '/';
    return true;
  }

  if (!auth.isAuthenticated) {
    /* Настроенный терминал ведёт на экран ввода табельного номера,
       а не на форму логина с паролем: оператор пароля не знает. */
    return auth.terminal ? '/terminal' : '/login';
  }

  if (to.meta.roles && !to.meta.roles.includes(auth.role)) {
    return HOME_BY_ROLE[auth.role] || '/login';
  }
  return true;
});
